// 画像アップロード監視
import { updateAlbumImage, albumImages } from "./state.js";
import { initializeImageTransform } from "./imageTransforms.js";

// MutationObserverでファイルアップロードコンテナを監視
export const observeUploadContainers = (drawMainAlbumCanvasCallback) => {
  for (let i = 1; i <= 4; i++) {
    const imageIndex = i;
    const formattedImageIndex = imageIndex.toString().padStart(2, "0");
    const containerId = `js_dd_show_mase_case_entry_type_a1_itemFile${formattedImageIndex}`;
    const targetNode = document.getElementById(containerId);

    if (targetNode) {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              console.log(`[MutationObserver ${imageIndex}] Node added:`, node.tagName, node);

              let imgNode = null;
              if (node.tagName === "IMG" && node.src && node.src.startsWith("data:image/")) {
                imgNode = node;
              } else if (node.nodeType === Node.ELEMENT_NODE && node.querySelector("img[src^='data:image']")) {
                // 追加されたノードが直接IMGでない場合、子要素からIMGを探す
                imgNode = node.querySelector("img[src^='data:image']");
                if (imgNode) {
                  console.log(`[MutationObserver ${imageIndex}] Found IMG tag inside added node:`, imgNode.src.substring(0, 50) + "...");
                }
              }

              if (imgNode) {
                const imageSource = imgNode.src; // nullチェック後にsrcを参照
                console.log(`[MutationObserver ${imageIndex}] IMG tag detected with data:image src:`, imageSource.substring(0, 50) + "...");
                const tempImg = new Image();
                tempImg.onload = () => {
                  console.log(`[MutationObserver ${imageIndex}] tempImg loaded. Original dimensions: ${tempImg.width}x${tempImg.height}`);
                  console.log(`[MutationObserver ${imageIndex}] Before updating albumImages[${imageIndex - 1}]:`, JSON.parse(JSON.stringify(albumImages[imageIndex - 1])));

                  updateAlbumImage(imageIndex - 1, {
                    src: imageSource,
                    originalWidth: tempImg.width,
                    originalHeight: tempImg.height,
                  });

                  console.log(`[MutationObserver ${imageIndex}] After updating albumImages[${imageIndex - 1}]`);

                  // 画像アップロード時に変換情報を初期化
                  initializeImageTransform(imageIndex - 1);

                  if (drawMainAlbumCanvasCallback) {
                    drawMainAlbumCanvasCallback();
                  }
                };
                tempImg.onerror = () => {
                  console.error(`[MutationObserver ${imageIndex}] Error loading image for main preview from MutationObserver. Src: ${imageSource.substring(0, 100)}...`);
                  updateAlbumImage(imageIndex - 1, null);

                  // 画像エラー時に変換情報をリセット
                  initializeImageTransform(imageIndex - 1);

                  if (drawMainAlbumCanvasCallback) {
                    drawMainAlbumCanvasCallback();
                  }
                };
                tempImg.src = imageSource;
              } else if (node.tagName === "DIV" && node.classList.contains("f-message") && node.classList.contains("error")) {
                console.log(`[MutationObserver ${imageIndex}] Image upload error DIV detected.`);
                updateAlbumImage(imageIndex - 1, null);

                // エラー時に変換情報をリセット
                initializeImageTransform(imageIndex - 1);

                if (drawMainAlbumCanvasCallback) {
                  drawMainAlbumCanvasCallback();
                }
              }
            });
          } else if (mutation.type === "childList" && mutation.removedNodes.length > 0) {
            mutation.removedNodes.forEach((node) => {
              if (node.tagName === "IMG" || (node.querySelector && node.querySelector("img"))) {
                console.log(`[MutationObserver ${imageIndex}] Image removed detected.`);
                updateAlbumImage(imageIndex - 1, null);

                // 画像削除時に変換情報をリセット
                initializeImageTransform(imageIndex - 1);

                if (drawMainAlbumCanvasCallback) {
                  drawMainAlbumCanvasCallback();
                }
              }
            });
          }
        }
      });
      observer.observe(targetNode, { childList: true, subtree: true });
      console.log(`MutationObserver set up for ${containerId}`);

      // 既存の画像をチェック
      const existingImage = targetNode.querySelector("img");
      if (existingImage && existingImage.src && existingImage.src.startsWith("data:image/")) {
        console.log(`[MutationObserver ${imageIndex}] Initial image detected.`);
        let initialImgNode = existingImage; // 初期画像ノード

        const tempImg = new Image();
        tempImg.onload = () => {
          console.log(`[MutationObserver ${imageIndex}] Initial tempImg loaded. Original dimensions: ${tempImg.width}x${tempImg.height}`);
          updateAlbumImage(imageIndex - 1, {
            src: initialImgNode.src,
            originalWidth: tempImg.width,
            originalHeight: tempImg.height,
          });

          // 初期画像検出時に変換情報を初期化
          initializeImageTransform(imageIndex - 1);

          if (drawMainAlbumCanvasCallback) {
            drawMainAlbumCanvasCallback();
          }
        };
        tempImg.onerror = () => {
          console.error(`[MutationObserver ${imageIndex}] Error loading initial image for main preview. Src: ${initialImgNode.src.substring(0, 100)}...`);
          updateAlbumImage(imageIndex - 1, null);

          // 初期画像エラー時に変換情報をリセット
          initializeImageTransform(imageIndex - 1);

          if (drawMainAlbumCanvasCallback) {
            drawMainAlbumCanvasCallback();
          }
        };
        tempImg.src = initialImgNode.src;
      }
    } else {
      console.warn(`Upload container ${containerId} not found for MutationObserver.`);
    }
  }
};
